<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="在途预入库" name="op">
			<div class="content-box">
				<edit-in-bound type="pre"></edit-in-bound>
			</div>
		</el-tab-pane>
		<el-tab-pane label="预售在途记录" name="his">
			<his v-if="activeName=='his'" :type="[24]"></his>
		</el-tab-pane>
		<el-tab-pane label="预售在途库存" name="stock">
			<div class="content-box" v-if="activeName=='stock'">
				<div class="operator">
					<div class="operator-col">
						<classify-input v-model="filterClassify" size="mini"></classify-input>
					</div>
					<div class="operator-col">
						<brand-input v-model="filterBrand"></brand-input>
					</div>
					<div class="operator-col">
						<season-input v-model="filterSeason"></season-input>
					</div>
					<div class="operator-col">
						<el-input
							size="mini"
							v-model="filterTableSearch"
							placeholder="SPU 名/码"
							suffix-icon="el-icon-search"
							clearable
						></el-input>
					</div>
					<div class="operator-col">
						<el-input
							size="mini"
							v-model="filterTableSearchColor"
							placeholder="颜色 名/码"
							suffix-icon="el-icon-search"
							clearable
						></el-input>
					</div>
					<div class="operator-col">
						<editor-relateid
							size="mini"
							v-model="filterModel"
							data-model-name="Model"
							:name-fields="['name']"
							:params="{allowCreate:false,placeholder:'搜索尺寸'}"
						></editor-relateid>
					</div>

					<div class="operator-col">
						<bool-filter
							size="mini"
							v-model="filterIsSpecial.value"
							suffix-icon="el-icon-search"
							clearable
							data-model-name="Item"
							field="is_special"
							field-name="是否特价"
						></bool-filter>
					</div>
					<div class="operator-col">
						<el-button size="mini" type="primary" @click="doExport(editorDataModel)">导出</el-button>
					</div>
				</div>
				<curd-table
					ref="listTable"
					data-model="Item"
					:has-op-slot="true"
					:fields="preStocktableFields"
					:has-delete="false"
					list-url="inventory/list_all_stocks_pre/"
					:search-filter="filterTableSearch"
					:kv-filter="kvFilter"
				>
					<template slot="listOp" slot-scope="scope">
						<el-button size="mini" type="text" @click="goTxInfo(scope.row._id)">详情</el-button>
					</template>
				</curd-table>
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import His from "@/views/Inventory/subs/His.vue";
import EditInBound from "@/views/Inventory/subs/EditInbound";
import StockTable from "@/views/Inventory/subs/StockTable.vue";
import Filters from "@/mixins/Filters.js";
import FilterSeason from "@/mixins/Filter/FilterSeason.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import CurdPage from "@/mixins/CurdPage.js";
import { RenderPrice } from "@/mixinsApp/Render.js";

export default {
	mixins: [TabPage, CurdPage, Filters, FilterSeason, FilterModel, FilterClassify],
	components: {
		His,
		EditInBound,
	},
	data() {
		return {
			activeName: "op",
			filterIsSpecial: { field: "is_special", value: null },

			filterTableSearchColor: "",
			preStocktableFields: [
				{
					name: "show_id",
					sortable: "custom",
					needThumb: "thumb_img",
					params: {
						width: "120px",
					},
				},
				{
					name: "brand",
					sortable: "custom",
				},
				{
					name: "product_color",
					sortable: "custom",
					params: {
						width: "150px",
					},
				},
				{
					name: "color_name",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
				{
					name: "model",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
				{
					name: "price_0",
					sortable: "custom",
					params: {
						isRight: true,
					},
				},
				{
					name: "cost_per",
					sortable: "custom",
					params: {
						isRight: true,
					},
					privilege: [59],
				},

				{
					name: "price_1",
					sortable: false,
					params: {
						isRight: true,
					},
					render: info => {
						return RenderPrice(info, "price_1");
					},
				},
				{
					name: "price_2",
					sortable: false,
					params: {
						isRight: true,
					},
					render: info => {
						return RenderPrice(info, "price_2");
					},
				},
				{
					name: "price_3",
					sortable: false,
					params: {
						isRight: true,
					},
					render: info => {
						return RenderPrice(info, "price_3");
					},
				},
				{
					name: "price_4",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: info => {
						return RenderPrice(info, "price_3");
					},
					privilege: [13],
				},
				{
					name: "price_in_active",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},

					privilege: [13],
				},
				{
					name: "amount_pre",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
					privilege: [53],
				},
				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
					privilege: [53],
				},
				{
					name: "amount_temporary",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
					privilege: [53],
				},
			],
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
